module.exports = __webpack_public_path__ + "img/39_004_010.ee27804f.png";